import { JobCatalogTreeLevelNodeFragment } from 'generated/resources/graphql'

export const getContractVersionJobCatalogTreeLevelNode = (
  jobCatalogTreeLevelNodes?: JobCatalogTreeLevelNodeFragment[],
  jobCatalogTreeNodeUuid?: string | null
) => {
  return jobCatalogTreeLevelNodes?.find((node) => node.uuid === jobCatalogTreeNodeUuid)
}
